import { createAnnotation } from "@routes/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleNonParagraphProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import { cn, getMimeTypeIcon } from "@util/helpers";
import parse, { DOMNode, domToReact } from "html-react-parser";

/**
 * Renders a Graphic element that displays icons based on the class names of span elements.
 * It processes the body string to replace span elements with corresponding icons.
 */
const Graphic = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps) => {
  const transformAnnotation = createAnnotation({});

  const transformSpan = (
    node: DOMNode
  ): string | boolean | void | object | null => {
    if (!node || node.type !== "tag") return null;

    if (node.name === "span") {
      const className = node.attribs.class || "";
      const classNameSplit = className.split(" ");

      const findIcon = classNameSplit
        .find((cls) => cls.startsWith("icon-") || cls.startsWith("icon_"))
        ?.replace("-", ".")
        .replace("_", ".");

      const getIcon = getMimeTypeIcon(findIcon || "");

      return (
        <span
          className="inline-block h-4 w-4 bg-center bg-no-repeat align-middle"
          style={{ backgroundImage: `url(${getIcon})` }}
        ></span>
      );
    }

    return domToReact([node], { replace: transformAnnotation });
  };

  const transformGraphic = (
    node: DOMNode
  ): string | boolean | void | object | null => {
    if (!node || node.type !== "tag") return null;

    const children = node.children as DOMNode[];

    return (
      <div
        className={cn("mb-6", className, paragraphWidth)}
        data-testid="article-graphic-component"
      >
        {domToReact(children, {
          replace: transformSpan,
        })}
      </div>
    );
  };

  return <>{parse(bodyString, { replace: transformGraphic })}</>;
};

export default Graphic;
